import { useState, useEffect } from 'react';

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? Math.min((scrollTop / docHeight) * 100, 100) : 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 h-[3px] z-[60] pointer-events-none">
      {/* 底色轨道 */}
      <div className="absolute inset-0 bg-background-200/30" />
      {/* 进度条 */}
      <div
        className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary-400 via-gold-500 to-accent-400 transition-all duration-150 ease-out rounded-r-full"
        style={{ width: `${progress}%` }}
      />
      {/* 顶端光点 */}
      <div
        className="absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-gold-400 shadow-[0_0_10px_oklch(var(--accent-400)/0.6)] animate-pulse-slow transition-all duration-150 ease-out"
        style={{ left: `calc(${progress}% - 6px)`, opacity: progress > 0 ? 1 : 0 }}
      />
    </div>
  );
}